import { Switch } from "@headlessui/react"
import { OptionValue, ProductOption } from "@lib/swell/storefront-data-hooks/src/types"
import { classNames } from "core/utils"
import { useFormikContext, useField } from "formik"
import Image from "next/legacy/image"
import { useState, useEffect } from "react"
import { getPrice } from "@lib/swell/storefront-data-hooks/src/utils/product"

interface ToggleFieldProps {
  option: ProductOption
  updateSelectionChange: any
}
const ToggleField = ({ option, updateSelectionChange }: ToggleFieldProps) => {
  const { name, description } = option
  const optionValue = option.values[0]
  const optionValueId = optionValue.id
  const { isSubmitting } = useFormikContext()
  const [input] = useField(name)
  const [enabled, setEnabled] = useState(false)

  return (
    <Switch.Group
      as="div"
      className="flex items-center justify-between rounded-lg border border-gray-300 p-4"
    >
      <span className="flex grow flex-col">
        <Switch.Label as="span" className="text-sm font-medium text-gray-900" passive>
          {name}
          {/* <span className="text-gray-500 text-xs">
            {optionValue.price ? ` ${getPrice(optionValue.price, "usd")}` : <></>}
          </span> */}
        </Switch.Label>
        <Switch.Description as="span" className="text-sm text-gray-500">
          {description}
        </Switch.Description>
      </span>
      {/* @ts-ignore */}
      <Switch
        {...input}
        disabled={isSubmitting}
        onChange={(value: boolean) => {
          setEnabled(value)
          input.onChange({ target: { value, name } })
          updateSelectionChange(name, optionValueId, value)
        }}
        checked={enabled}
        className={classNames(
          enabled ? "bg-primary-600" : "bg-gray-200",
          "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        )}
      >
        <span
          aria-hidden="true"
          className={classNames(
            enabled ? "translate-x-5" : "translate-x-0",
            "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out"
          )}
        />
      </Switch>
    </Switch.Group>
  )
}
export default ToggleField
